import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function RsyncCheatSheet() {
    return (
        <div className={globalStyles.article}>
            <h1>rsync cheat sheet</h1>

            <p>rsync copies files while only transferring the parts that changed, which makes it the standard
                tool for backups and syncing directories, locally or over SSH.</p>

            <h3>Core flags</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> rsync -avz /local/dir/ /backup/dir/<br/>
            </pre>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="2">Flags</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>-a</b></td>
                        <td>Archive mode — recursive, preserves permissions, timestamps, symlinks, ownership</td>
                    </tr>
                    <tr>
                        <td><b>-v</b></td>
                        <td>Verbose output</td>
                    </tr>
                    <tr>
                        <td><b>-z</b></td>
                        <td>Compress data during transfer</td>
                    </tr>
                    <tr>
                        <td><b>-P</b></td>
                        <td>Show progress and allow resuming partially transferred files</td>
                    </tr>
                    <tr>
                        <td><b>--delete</b></td>
                        <td>Remove files in the destination that no longer exist in the source (true mirror)</td>
                    </tr>
                    <tr>
                        <td><b>--dry-run</b></td>
                        <td>Show what would happen without changing anything — always run this first</td>
                    </tr>
                    <tr>
                        <td><b>-n</b></td>
                        <td>Shorthand for --dry-run</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <p>A trailing slash on the source matters: <code>rsync -av dir/ dest/</code> copies the
                <b> contents</b> of <code>dir</code> into <code>dest</code>; <code>rsync -av dir dest/</code>
                (no trailing slash) copies <code>dir</code> itself as a subdirectory of <code>dest</code>.</p>

            <h3>Over SSH</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> rsync -avz -e ssh /local/dir/ julian@backup-host:/remote/dir/<br/>
    <b>user@host:~$</b> rsync -avz -e "ssh -p 2222" /local/dir/ julian@backup-host:/remote/dir/<br/>
            </pre>

            <h3>Excluding files</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> rsync -av --exclude 'node_modules' --exclude '*.log' src/ dest/<br/>
    <b>user@host:~$</b> rsync -av --exclude-from='.rsyncignore' src/ dest/<br/>
            </pre>

            <h3>Mirror with a dry run first</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> rsync -avz --delete --dry-run /local/dir/ julian@backup-host:/remote/dir/<br/>
    <b>user@host:~$</b> rsync -avz --delete /local/dir/ julian@backup-host:/remote/dir/ <i># run it for real</i><br/>
            </pre>
        </div>
    )
}
